import React, { Component } from 'react';
import PropTypes from 'prop-types';

const LEFT = 'left';
const RIGHT = 'right';
const TOP = 'top';
const BOTTOM = 'bottom';

class Tip extends Component {
    constructor(props) {
        super(props);

        this.getStyle = this.getStyle.bind(this);
    }

    getStyle() {
        if (!this.props.target) {
            return;
        }

        const { width: targetWidth, height: targetHeight } = this.props.target.getBoundingClientRect();
        let style;

        switch (this.props.placement) {
            case LEFT:
                return { left: `calc(100% - ${targetWidth/2}px)` };
            case RIGHT:
                return { left: `${targetWidth/2}px` };
            case TOP:
                return { top : `calc(100% - ${targetHeight/2}px)` };
            case BOTTOM:
                return { top: `${targetHeight/2}px` };
            default:
                break;
        }

        return style;
    }

    render() {
        const style = this.getStyle();

        return (
            <div className="tip" style={style}></div>
        );
    }
}

Tip.propTypes = {
    target: PropTypes.shape({
        getBoundingClientRect: PropTypes.func
    }),
    placement: PropTypes.string
};

export default Tip;
